import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ShellComponent } from "./shell/shell.component";
import { LoginComponent } from "./login/login.component";
import { AuthGuard } from "./core/interceptors/auth-guard";
import { ManageLicensesComponent } from "./manageLicenses/manageLicenses.component";
import { AccountComponent } from "./account/account.component";
import { DownloadsComponent } from "./downloads/downloads.component";
import { RegisterComponent } from "./register/register.component";
import { ResetComponent } from "./reset/reset.component";
import { DashboardComponent } from "./dashboard/dashboard.component";

const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    data: { requiresLogin: false },
  },
  {
    path: "register",
    component: RegisterComponent,
    data: { requiresLogin: false },
  },
  {
    path: "reset",
    component: ResetComponent,
    data: { requiresLogin: false },
  },
  {
    path: "",
    component: ShellComponent,
    data: { requiresLogin: true },
    canActivate: [AuthGuard],
    children: [
      {
        path: "home",
        component: DashboardComponent,
        data: { requiresLogin: true },
        canActivate: [AuthGuard],
      },
      {
        path: "licenses",
        component: ManageLicensesComponent,
        data: { requiresLogin: true },
        canActivate: [AuthGuard],
      },
      {
        path: "account",
        component: AccountComponent,
        data: { requiresLogin: true },
        canActivate: [AuthGuard],
      },
      {
        path: "downloads",
        component: DownloadsComponent,
        data: { requiresLogin: true },
        canActivate: [AuthGuard],
      },
      { path: "", pathMatch: "full", redirectTo: "home" },
    ],
  },
  {
    path: "**",
    redirectTo: "login",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
